const jobSeries = {
    "0000": "Miscellaneous Occupations Group",
    "0006": "Correctional Institution Administration Series",
    "0007": "Correctional Officer Series",
    "0017": "Explosives Safety Series",
    "0018": "Safety and Occupational Health Management Series",
    "0019": "Safety Technician Series",
    "0020": "Community Planning Series",
    "0023": "Outdoor Recreation Planning Series",
    "0025": "Park Ranger Series",
    "0028": "Environmental Protection Specialist Series",
    "0060": "Chaplain Series",
    "0062": "Clothing Design Series",
    "0072": "Fingerprint Identification Series",
    "0080": "Security Administration Series",
    "0081": "Fire Protection and Prevention Series",
    "0082": "United States Marshal Series",
    "0083": "Police Series",
    "0084": "Nuclear Materials Courier Series",
    "0085": "Security Guard Series",
    "0086": "Security Clerical and Assistance Series",
    "0089": "Emergency Management Series",
    "0090": "Guide Series",
    "0095": "Foreign Law Specialist Series",
    "0100": "Social Science, Psychology, and Welfare Group",
    "0105": "Social Insurance Administration Series",
    "0106": "Unemployment Insurance Series",
    "0110": "Economist Series",
    "0132": "Intelligence Series",
    "0136": "International Cooperation Series",
    "0142": "Workforce Development Series",
    "0150": "Geography Series",
    "0160": "Civil Rights Analysis Series",
    "0170": "History Series",
    "0180": "Psychology Series",
    "0184": "Sociology Series",
    "0185": "Social Work Series",
    "0186": "Social Services Aid and Assistant Series",
    "0187": "Social Services Series",
    "0188": "Recreation Specialist Series",
    "0189": "Recreation Aid and Assistant Series",
    "0193": "Archeology Series",
    "0200": "Human Resources Management Group",
    "0201": "Human Resources Management",
    "0203": "Human Resources Assistance",
    "0241": "Mediation Series",
    "0243": "Apprenticeship and Training Series",
    "0244": "Labor Management Relations Examining Series",
    "0260": "Equal Employment Opportunity Series",
    "0300": "General Administrative, Clerical, and Office Services Group",
    "0301": "Miscellaneous Administration and Program Series",
    "0302": "Messenger Series",
    "0303": "Miscellaneous Clerk and Assistant Series",
    "0304": "Information Receptionist Series",
    "0305": "Mail and File Series",
    "0306": "Government Information Series",
    "0308": "Records and Information Management Series",
    "0309": "Correspondence Clerk Series",
    "0313": "Work Unit Supervising Series",
    "0318": "Secretary Series",
    "0319": "Closed Microphone Reporting Series",
    "0322": "Clerk-Typist Series",
    "0326": "Office Automation Clerical and Assistance Series",
    "0332": "Computer Operation Series",
    "0335": "Computer Clerk and Assistant Series",
    "0340": "Program Management Series",
    "0341": "Administrative Officer Series",
    "0342": "Support Services Administration Series",
    "0343": "Management and Program Analysis Series",
    "0344": "Management and Program Clerical and Assistance Series",
    "0346": "Logistics Management Series",
    "0350": "Equipment Operator Series",
    "0356": "Data Transcriber Series",
    "0357": "Coding Series",
    "0360": "Equal Opportunity Compliance Series",
    "0361": "Equal Opportunity Assistance Series",
    "0382": "Telephone Operating Series",
    "0390": "Telecommunications Processing Series",
    "0391": "Telecommunications Series",
    "0392": "General Telecommunication Series",
    "0394": "Communications Clerical Series",
    "0400": "Natural Resources Management and Biological Sciences Group",
    "0401": "General Natural Resources Management and Biological Sciences",
    "0403": "Microbiology",
    "0405": "Pharmacology",
    "0408": "Ecology",
    "0410": "Zoology",
    "0413": "Physiology",
    "0414": "Entomology",
    "0415": "Toxicology",
    "0430": "Botany",
    "0434": "Plant Pathology",
    "0435": "Plant Physiology",
    "0437": "Horticulture",
    "0440": "Genetics",
    "0454": "Rangeland Management",
    "0457": "Soil Conservation",
    "0460": "Forestry",
    "0470": "Soil Science",
    "0471": "Agronomy",
    "0480": "Fish and Wildlife Administration",
    "0482": "Fish Biology",
    "0485": "Wildlife Refuge Management",
    "0486": "Wildlife Biology",
    "0487": "Animal Science",
    "0404": "Biological Science Technician Series",
    "0421": "Plant Protection Technician Series",
    "0455": "Range Technician Series",
    "0456": "Wildland Fire Management Series",
    "0458": "Soil Conservation Technician Series",
    "0459": "Irrigation System Operation Series",
    "0462": "Forestry Technician Series",
    "0500": "Accounting and Budget Group",
    "0501": "Financial Administration and Program",
    "0510": "Accounting",
    "0511": "Auditing",
    "0560": "Budget Analysis",
    "0512": "Internal Revenue Agent",
    "0526": "Tax Specialist",
    "0503": "Financial Clerical and Technician",
    "0525": "Accounting Technician",
    "0530": "Cash Processing",
    "0540": "Voucher Examining",
    "0544": "Civilian Pay",
    "0545": "Military Pay",
    "0561": "Budget Clerical and Assistance",
    "0592": "Tax Examining",
    "0593": "Insurance Accounts",
    "0505": "Financial Management Series",
    "0600": "Medical, Hospital, Dental, and Public Health Group",
    "0675": "Medical Records Technician Series",
    "0679": "Medical Support Assistance Series",
    "0601": "General Medical and Healthcare Series",
    "0602": "Physician Series",
    "0603": "Physician Assistant Series",
    "0610": "Nursing Series",
    "0630": "Dietetics and Nutrition Series",
    "0631": "Occupational Therapy Series",
    "0633": "Physical Therapy Series",
    "0635": "Kinesiotherapy Series",
    "0638": "Recreation/Creative Arts Therapy Series",
    "0644": "Clinical Laboratory Series",
    "0660": "Pharmacy Series",
    "0662": "Optometry Series",
    "0665": "Speech/Language Pathology and Audiology Series",
    "0668": "Podiatry Series",
    "0680": "Dentistry Series",
    "0690": "Industrial Hygiene Series",
    "0696": "Consumer Safety Series",
    "0620": "Practical (Vocational) Nurse Series",
    "0621": "Nursing Assistant Series",
    "0622": "Medical Supply Aide and Technician Series",
    "0636": "Rehabilitation Therapy Assistant Series",
    "0640": "Health Aid and Technician Series",
    "0645": "Medical Technician Series",
    "0646": "Pathology Technician Series",
    "0647": "Diagnostic Radiologic Technologist Series",
    "0648": "Therapeutic Radiologic Technologist Series",
    "0649": "Medical Instrument Technician Series",
    "0651": "Respiratory Therapist Series",
    "0661": "Pharmacy Technician Series",
    "0667": "Orthotist and Prosthetist Series",
    "0669": "Medical Records Administration Series",
    "0670": "Health System Administration Series",
    "0671": "Health System Specialist Series",
    "0673": "Hospital Housekeeping Management Series",
    "0681": "Dental Assistant Series",
    "0682": "Dental Hygiene Series",
    "0683": "Dental Laboratory Aid and Technician Series",
    "0685": "Public Health Program Specialist Series",
    "0688": "Sanitarian Series",
    "0698": "Environmental Health Technician Series",
    "0700": "Veterinary Medical Science Group",
    "0701": "Veterinary Medical Science Series",
    "0704": "Animal Health Technician Series",
    "0800": "Engineering and Architecture Group",
    "0801": "General Engineering",
    "0803": "Safety Engineering",
    "0804": "Fire Protection Engineering",
    "0806": "Materials Engineering",
    "0807": "Landscape Architecture",
    "0808": "Architecture",
    "0810": "Civil Engineering",
    "0819": "Environmental Engineering",
    "0830": "Mechanical Engineering",
    "0840": "Nuclear Engineering",
    "0850": "Electrical Engineering",
    "0854": "Computer Engineering",
    "0855": "Electronics Engineering",
    "0858": "Bioengineering and Biomedical Engineering",
    "0861": "Aerospace Engineering",
    "0871": "Naval Architecture",
    "0880": "Mining Engineering",
    "0881": "Petroleum Engineering",
    "0890": "Agricultural Engineering",
    "0893": "Chemical Engineering",
    "0896": "Industrial Engineering",
    "0802": "Engineering Technical",
    "0809": "Construction Control Technical",
    "0817": "Survey Technical",
    "0856": "Electronics Technical",
    "0873": "Marine Survey Technical",
    "0895": "Industrial Engineering Technical",
    "0828": "Construction Analyst Series",
    "0900": "Legal and Kindred Group",
    "0962": "Contact Representative",
    "0963": "Legal Instruments Examining",
    "0986": "Legal Assistance",
    "0998": "Claims Assistance and Examining",
    "0901": "General Legal and Kindred Administration Series",
    "0905": "General Attorney Series",
    "0950": "Paralegal Specialist Series",
    "0965": "Land Law Examining Series",
    "0967": "Passport and Visa Examining Series",
    "0991": "Workers' Compensation Claims Examining Series",
    "0993": "Railroad Retirement Claims Examining Series",
    "0996": "Veteran Claims Examining Series",
    "1000": "Information and Arts Group",
    "1008": "Interior Design Series",
    "1010": "Exhibits Specialist Series",
    "1015": "Museum Curator Series",
    "1016": "Museum Specialist and Technician Series",
    "1020": "Illustrating Series",
    "1021": "Office Drafting Series",
    "1035": "Public Affairs Series",
    "1040": "Language Specialist Series",
    "1046": "Language Clerical Series",
    "1060": "Photography Series",
    "1071": "Audiovisual Production Series",
    "1082": "Writing and Editing Series",
    "1083": "Technical Writing and Editing Series",
    "1084": "Visual Information Series",
    "1087": "Editorial Assistance Series",
    "1100": "Business and Industry Group",
    "1102": "Contracting Series",
    "1103": "Industrial Property Management Series",
    "1104": "Property Disposal Series",
    "1105": "Purchasing Series",
    "1106": "Procurement Clerical and Technician Series",
    "1107": "Property Disposal Clerical and Technician Series",
    "1109": "Grants Management Series",
    "1140": "Trade Specialist Series",
    "1144": "Commissary Management Series",
    "1145": "Agricultural Program Specialist Series",
    "1146": "Agricultural Marketing Series",
    "1147": "Agricultural Market Reporting Series",
    "1150": "Industrial Specialist Series",
    "1152": "Production Control Series",
    "1160": "Financial Analysis Series",
    "1163": "Insurance Examining Series",
    "1165": "Loan Specialist Series",
    "1169": "Internal Revenue Officer Series",
    "1170": "Realty Series",
    "1171": "Appraising Series",
    "1173": "Housing Management Series",
    "1176": "Building Management Series",
    "1200": "Copyright, Patent, and Trademark Group",
    "1221": "Patent Advisor Series",
    "1222": "Patent Attorney Series",
    "1223": "Patent Classifying Series",
    "1224": "Patent Examining Series",
    "1226": "Design Patent Examining Series",
    "1300": "Physical Sciences Group",
    "1301": "General Physical Science",
    "1306": "Health Physics",
    "1310": "Physics",
    "1313": "Geophysics",
    "1315": "Hydrology",
    "1320": "Chemistry",
    "1321": "Metallurgy",
    "1330": "Astronomy and Space Science",
    "1340": "Meteorology",
    "1350": "Geology",
    "1360": "Oceanography",
    "1370": "Cartography",
    "1372": "Geodesy",
    "1373": "Land Surveying",
    "1380": "Forest Products Technology",
    "1382": "Food Technology",
    "1384": "Textile Technology",
    "1386": "Photographic Technology",
    "1311": "Physical Science Technician",
    "1316": "Hydrologic Technician",
    "1341": "Meteorological Technician",
    "1371": "Cartographic Technician",
    "1374": "Geodetic Technician",
    "1361": "Navigational Information Series",
    "1400": "Library and Archives Group",
    "1410": "Librarian Series",
    "1411": "Library Technician Series",
    "1412": "Technical Information Services Series",
    "1420": "Archivist Series",
    "1421": "Archives Technician Series",
    "1500": "Mathematics and Statistics Group",
    "1501": "General Mathematics and Statistics",
    "1510": "Actuarial Science",
    "1515": "Operations Research",
    "1520": "Mathematics",
    "1529": "Mathematical Statistics",
    "1530": "Statistics",
    "1521": "Mathematics Technician Series",
    "1531": "Statistical Assistant Series",
    "1550": "Computer Science Series",
    "1560": "Data Science Series",
    "1600": "Equipment, Facilities, and Services Group",
    "1601": "Equipment, Facilities, and Services",
    "1630": "Cemetery Administration Services",
    "1640": "Facility Operations Services",
    "1654": "Printing Services",
    "1658": "Laundry Operations Services",
    "1667": "Food Services",
    "1670": "Equipment Services",
    "1603": "Equipment, Facilities, and Services Assistance Series",
    "1700": "Education Group",
    "1701": "General Education and Training Series",
    "1702": "Education and Training Technician Series",
    "1710": "Education and Vocational Training Series",
    "1712": "Training Instruction Series",
    "1715": "Vocational Rehabilitation Series",
    "1720": "Education Program Series",
    "1730": "Education Research Series",
    "1740": "Education Services Series",
    "1750": "Instructional Systems Series",
    "1800": "Administrative Work in the Inspection, Investigation, Enforcement, and Compliance Group",
    "1801": "General Inspection, Investigation, Enforcement, and Compliance",
    "1805": "Investigative Analysis",
    "1810": "General Investigation",
    "1811": "Criminal Investigation",
    "1822": "Mine Safety and Health Inspection",
    "1849": "Wage and Hour Investigation",
    "1850": "Agricultural Warehouse Inspection",
    "1860": "Equal Opportunity Investigation",
    "1881": "Customs and Border Protection Interdiction",
    "1889": "Import Compliance",
    "1895": "Customs and Border Protection",
    "1896": "Border Patrol Enforcement",
    "1802": "Compliance Inspection and Support Series",
    "1815": "Air Safety Investigating Series",
    "1825": "Aviation Safety Series",
    "1862": "Consumer Safety Inspection Series",
    "1863": "Food Inspection Series",
    "1894": "Customs Entry and Liquidating Series",
    "1900": "Quality Assurance, Inspection, and Grading Group",
    "1910": "Quality Assurance Series",
    "1980": "Agricultural Commodity Grading Series",
    "2000": "Supply Group",
    "2001": "General Supply Series",
    "2003": "Supply Program Management Series",
    "2005": "Supply Clerical and Technician Series",
    "2010": "Inventory Management Series",
    "2030": "Distribution Facilities and Storage Management Series",
    "2032": "Packaging Series",
    "2091": "Sales Store Clerical Series",
    "2100": "Transportation Group",
    "2102": "Transportation Clerk and Assistant Series",
    "2110": "Transportation Industry Analysis Series",
    "2121": "Railroad Safety Series",
    "2123": "Motor Carrier Safety Series",
    "2125": "Highway Safety Series",
    "2130": "Traffic Management Series",
    "2131": "Freight Rate Series",
    "2144": "Cargo Scheduling Series",
    "2151": "Dispatching Series",
    "2152": "Air Traffic Control Series",
    "2154": "Air Traffic Assistance Series",
    "2161": "Marine Cargo Series",
    "2181": "Aircraft Operations Series",
    "2183": "Air Navigation Series",
    "2185": "Aircrew Technician Series",
    "2200": "Information Technology Group",
    "2210": "Information Technology Management"
};

export const getJobSeriesDescription = (key) => {
    return jobSeries[key] || `Unknown Job Series (${key})`;
  };
  
export default jobSeries;
